<article class="relative mt-8">
	<div class="h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-2/5">
		<img
			class="object-cover w-full h-full rounded-lg"
			[src]="image() | cdn"
			[attr.alt]="name()"
		/>
	</div>
	<div class="pt-8 mx-auto md:pl-8 md:py-4 lg:pl-16">
		<div class="md:ml-auto md:w-3/5">
			<h3 class="text-xl font-bold text-gray-900">{{ name() | ucEntities }}</h3>
			<p
				class="mt-2 text-base text-gray-500"
				[innerHtml]="description() | ucEntities"
			></p>
			@if (externalUrl()) {
				<uc-visit-website-btn
					customStyles="mt-6 w-full md:w-auto"
					[externalUrl]="externalUrl()"
					[product]="product()"
					[componentName]="componentName()"
					[uniId]="uniId()"
					buttonText="Visit Website"
					[source]="uniName()"
					sourceType="uni"
					[ugSearchOrderPosition]="ugSearchOrderPosition()"
					[uniName]="uniName()"
				/>
			}
		</div>
	</div>
</article>
